import { render, staticRenderFns } from "./chagetov.vue?vue&type=template&id=38edee60&"
import script from "./chagetov.vue?vue&type=script&lang=js&"
export * from "./chagetov.vue?vue&type=script&lang=js&"
import style0 from "./chagetov.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports